import * as React from 'react';

import './Appbar.css';

function Appbar(): React.JSX.Element {
  return (
    <div className="Appbar">
      <div className="Appbar-container">
        <h3 className="title">Basket</h3>
      </div>
    </div>
  );
}


export default Appbar;
